export enum NdfTestScheduleType {
    ELAPSED = 'ELAPSED',
    SPECIFIC = 'SPECIFIC',
}
